import * as requestFromServer from "./orderlinesCrud";
import { orderlinesSlice, callTypes } from "./orderlinesSlice";
import { toast } from "react-hot-toast";
import { OrderLineType } from "./types";
import { AxiosResponse } from "axios";
import { Dispatch } from "redux";

const { actions } = orderlinesSlice;

export const createOrderline = (orderLine: OrderLineType) => (
  dispatch: Dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .CreateOrderline(orderLine)
    .then((response: AxiosResponse) => {
      const orderline = response.data;
      dispatch(actions.lineCreated({ orderline }));
    })
    .catch((error: unknown) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      toast.error("خطا در ایجاد کردن");
      throw error;
    });
};

export const getOrderlines = (id: string) => (dispatch: Dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return requestFromServer
    .GetOrderlines(id)
    .then((response: AxiosResponse) => {
      dispatch(actions.linesFetched(response.data));
    })
    .catch((error: unknown) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      toast.error("خطا در دریافت اطلاعات");
    });
};

export const deleteOrderline = (id: string) => (dispatch: Dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .DeleteOrderline(id)
    .then(() => {
      dispatch(actions.lineDeleted({ id }));
    })
    .catch((error: unknown) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      toast.error("خطا در حذف کردن");
    });
};
